import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import Layout from "../../containers/Layout/Layout";
import {
  loadLocationsAction,
  getLocations,
  isLoading,
  isSaving,
  getLessons,
  saveLessonAction,
  getSchedules,
  loadSchedulesAction,
  saveScheduleAction
} from "../../../state/data";
import Loader from "../../atomic/Loader/Loader";
import Panel from "../../atomic/Panel/Panel";
import FloatingButton from "../../atomic/FloatingButton/FloatingButton";
import LessonsTable from "../../partials/LessonsTable/LessonsTable";
import { Route, Switch, useParams, Redirect } from "react-router-dom";
import OneLessonPage from "../OneLessonPage/OneLessonPage";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { withTheme } from "styled-components";
import { Link } from "react-router-dom";
import Button from "../../atomic/Button/Button";
import ScheduleHeader from "./ScheduleHeader";
import CreateSchedule from "../../partials/CreateSchedule/CreateSchedule";
import ScheduleTable from "../../partials/ScheduleTable/ScheduleTable";

export function generateId() {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(c) {
    var r = (Math.random() * 16) | 0,
      v = c == "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

const ConfirmDiv = styled.div`
  width: 100%;
`;
const Buttons = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
`;

const DeleteSchedule = () => {
  const { scheduleId, locationId, lessonId } = useParams();
  const [requireRedirect, setRequireRedirect] = useState(false);
  const dispatch = useDispatch();
  const saving = useSelector(isSaving);
  useEffect(() => {
    if (saving) {
      setRequireRedirect(true);
    }
  }, [saving]);
  if (!saving && requireRedirect) {
    return <Redirect to={"/schedule/show/" + locationId + "/" + lessonId} />;
  }
  if (saving) {
    return <Loader />;
  }
  return (
    <ConfirmDiv>
      <div>Are you sure you want to cancel this lesson?</div>
      <Buttons>
        <Link to={"/schedule/show/" + locationId + "/" + lessonId}>
          <Button>Cancel</Button>
        </Link>
        <Button
          inverted
          onClick={() =>
            dispatch(saveScheduleAction({ id: scheduleId, status: "deleted" }))
          }
        >
          Delete
        </Button>
      </Buttons>
    </ConfirmDiv>
  );
};

const SchedulePage = withTheme(({ theme }) => {
  const lessons = useSelector(getLessons);
  const schedules = useSelector(getSchedules);
  const locs = useSelector(getLocations);
  const dispatch = useDispatch();
  const loading = useSelector(isLoading);
  const newId = generateId();
  const { locationId, lessonId } = useParams();
  const [lesson, setLesson] = useState("");
  const [location, setLocation] = useState("");
  useEffect(() => {
    if (!lessons) {
      dispatch(loadLocationsAction());
    }
  }, []);
  useEffect(() => {
    if (!schedules) {
      dispatch(loadSchedulesAction());
    }
  }, []);
  useEffect(() => {
    let lessonDef = "";
    let locationDef = "";
    if (lessons && locs && locationId && lessonId) {
      console.log("LESSONS and LOCS", lessons, locs, locationId, lessonId);
      lessonDef = lessons
        .filter(l => l.id === lessonId)
        .map(l => ({ value: l.id, label: l.name }))[0];
      locationDef = locs
        .filter(l => l.id === locationId)
        .map(l => ({ value: l.id, label: l.address }))[0];
      setLesson(lessonDef);
      setLocation(locationDef);
    }
    if (!locationDef && locs) {
      locationDef = locs
        .filter(l => l.status !== "deleted")
        .map(l => ({ value: l.id, label: l.address }))[0];
      setLocation(locationDef);
    }
    if (!lessonDef && lessons) {
      lessonDef = lessons
        .filter(l => l.status !== "deleted")
        .filter(
          l =>
            locationDef &&
            l.locations &&
            l.locations.filter(ll => ll === locationDef.value)[0]
        )
        .map(l => ({ value: l.id, label: l.name }))[0];
      if (lessonDef) {
        setLesson(lessonDef);
      }
    }
  }, [lessons, locs, locationId, lessonId]);
  if (!lessons || loading || !schedules) {
    return (
      <Layout>
        <Loader />
      </Layout>
    );
  }
  const locations = locs.filter(l => l.status !== "deleted");
  console.log("UUU", lesson, location);
  return (
    <Layout>
      <h1>Lessons Schedule</h1>
      <ScheduleHeader
        locations={locations}
        location={location}
        setLocation={setLocation}
        lessons={lessons
          .filter(l => l.status !== "deleted")
          .filter(
            l =>
              location &&
              l.locations &&
              l.locations.filter(i => location.value === i)[0]
          )}
        setLesson={setLesson}
        lesson={lesson}
      />
      <Switch>
        <Route path="/schedule" exact>
          <Redirect to="/schedule/show" />
        </Route>
        <Route path="/schedule/show">
          {location && lesson && (
            <>
              <h1>Schedules</h1>
              <Link
                to={
                  "/schedule/create/" +
                  location.value +
                  "/" +
                  lesson.value +
                  "/" +
                  newId
                }
              >
                <Button>
                  <FontAwesomeIcon
                    icon={["fas", "plus"]}
                    size="1x"
                    color={theme.color1}
                  />{" "}
                  Create
                </Button>
              </Link>
              <Panel>
                <ScheduleTable
                  schedules={schedules
                    .filter(s => s.status !== "deleted")
                    .filter(
                      s =>
                        s.lessonId === lesson.value &&
                        s.locationId === location.value
                    )}
                />
              </Panel>
            </>
          )}
        </Route>
        <Route path="/schedule/create/:locationId/:lessonId/:scheduleId">
          <Panel>
            <CreateSchedule location={location} lesson={lesson} />
          </Panel>
        </Route>
        <Route path="/schedule/delete/:locationId/:lessonId/:scheduleId">
          <Panel>
            <DeleteSchedule />
          </Panel>
        </Route>
      </Switch>
    </Layout>
  );
});

export default SchedulePage;
